import { type Dispatch, type SetStateAction } from "react";

import i18next from "i18next";

import enLocalizations from "@/src/localizations/en.json";
import fiLocalizations from "@/src/localizations/fi.json";

const LOCALE_KEY = "localeAtom";

const getPersistedLocale = (): "fi" | "en" => {
  try {
    const stored = localStorage.getItem(LOCALE_KEY);
    const parsed = stored ? JSON.parse(stored) : null;
    return parsed === "en" ? "en" : "fi";
  } catch {
    return "fi";
  }
};

export const initLocalization = async (): Promise<void> => {
  await i18next.init({
    lng: getPersistedLocale(),
    resources: {
      fi: {
        translation: fiLocalizations
      },
      en: {
        translation: enLocalizations
      }
    }
  });
};

export const changeLocale = (locale: "fi" | "en"): void => {
  i18next.changeLanguage(locale).catch(() => undefined);
};

export const toggleLanguage = (
  setLocale: Dispatch<SetStateAction<"fi" | "en">>
) => {
  setLocale((prevLocale) => {
    const newLocale = prevLocale === "fi" ? "en" : "fi";
    changeLocale(newLocale);
    return newLocale;
  });
};
